import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	dismiss: {
		id: 'confluence.project-pages.improvement.provisioning-modal-carousel.controls.dismiss',
		defaultMessage: 'Dismiss',
		description: 'Label of a button to allow users to dismiss the info modal',
	},
	next: {
		id: 'confluence.project-pages.improvement.provisioning-modal-carousel.controls.next',
		defaultMessage: 'Next',
		description: 'Label of a button to allow users to go to the next screen within the info modal',
	},
	done: {
		id: 'confluence.project-pages.improvement.provisioning-modal-carousel.controls.done',
		defaultMessage: 'Done',
		description:
			'Label of a button indicating that Jira provisioning is completed and users can dismiss the modal by clicking Done',
	},
});

export default messages;
